import styled from '@emotion/styled'

import type { Theme } from '@yuno/design-system-web'
import { TableCell, Icon, IconButton } from '@yuno/design-system-web'

export const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const EmptyWrapper = styled.div<{ theme?: Theme }>`
  height: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 35px;
`

export const StyledTableCellUrl = styled(TableCell)`
  width: 15%;
`
export const StyledTableCellEvent = styled(TableCell)`
  width: 15%;
  text-transform: capitalize;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`

export const IconContainer = styled(IconButton)`
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
`

export const StyledIconEdit = styled(Icon)<{ theme?: Theme }>`
  &:hover {
    color: ${({ theme }) => theme.palette.vivid.brand};
  }
`

export const StyledIconDelete = styled(Icon)<{ theme?: Theme }>`
  &:hover {
    color: ${({ theme }) => theme.palette.vivid.coral};
  }
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  height: 80px;
`

export const SwitchWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 14px 0 14px 11px;
`
export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const TagWrapper = styled.div`
  margin: 0 10px 0 0;
`

export const TableCellTagStyled = styled(TableCell)(
  ({ theme }: { theme?: Theme }) => ({
    '& .MuiChip-root': {
      padding: '0px',
    },
    '& .MuiChip-icon': {
      display: 'none',
    },
    width: '40%',
    display: 'table-cell',
  }),
)

export const DialogText = styled('span')(
  ({ theme }: { children: string; theme?: Theme }) => ({
    ...theme.typography.small.regular,
    color: theme.palette.neutral.black,
  }),
)
